// Available CS2 maps - Single source of truth
export const AVAILABLE_MAPS = [
  "Mirage",
  "Inferno",
  "Nuke",
  "Anubis",
  "Vertigo",
  "Ancient",
  "Cache",
  "Cobblestone 2018",
  "Dust II"
];

// Default maps selected for new users (all maps by default)
export const DEFAULT_MAPS_SELECTED = AVAILABLE_MAPS.map(map => 
  map.toLowerCase().replace(/\s+/g, "_")
);

// Wingman (2v2) map pool. Selection keys mirror the edge registry in
// edge/constants/wingmanMaps.js (kept in sync via edge/test/wingmanMaps.test.js).
// Match keys are NOT always "de_" + selectionKey (e.g. "cobblewingman",
// "gd_rialto") — always resolve them through WINGMAN_MATCH_MAP_BY_SELECTION_KEY.
export const AVAILABLE_WINGMAN_MAPS = [
  "Assembly",
  "Boyard",
  "Brewery",
  "Cobblestone Wingman",
  "Drawbridge",
  "Eldorado",
  "Foroglio",
  "Lake",
  "Memento",
  "Palais",
  "Rainfall",
  "Rialto",
  "Splat",
  "Trash",
  "Vandal"
];

export const DEFAULT_WINGMAN_MAPS_SELECTED = AVAILABLE_WINGMAN_MAPS.map(map =>
  map.toLowerCase().replace(/\s+/g, "_")
);

export const WINGMAN_MATCH_MAP_BY_SELECTION_KEY = {
  assembly: "de_assembly",
  boyard: "de_boyard",
  brewery: "de_brewery",
  cobblestone_wingman: "cobblewingman",
  drawbridge: "de_drawbridge",
  eldorado: "de_eldorado",
  foroglio: "de_foroglio",
  lake: "de_lake",
  memento: "de_memento",
  palais: "de_palais",
  rainfall: "de_rainfall",
  rialto: "gd_rialto",
  splat: "de_splat",
  trash: "de_trash",
  vandal: "de_vandal"
};

const WINGMAN_MATCH_MAP_IDS = new Set(Object.values(WINGMAN_MATCH_MAP_BY_SELECTION_KEY));

/**
 * Selection keys ("rialto", "mirage") and real match ids ("gd_rialto",
 * "cobblewingman", "de_mirage") both arrive here. Wingman names are resolved
 * from the registry so they are never de_-prefixed into a map CS2 cannot load.
 */
export function resolveMatchMapIdFromSelectionKey(selectionKey) {
  const key = String(selectionKey || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_");
  if (!key) return null;
  if (WINGMAN_MATCH_MAP_BY_SELECTION_KEY[key]) {
    return WINGMAN_MATCH_MAP_BY_SELECTION_KEY[key];
  }
  if (WINGMAN_MATCH_MAP_IDS.has(key) || key.startsWith("de_")) {
    return key;
  }
  return `de_${key}`;
}

// Format map name from snake_case to proper case
export const formatMapName = (mapName) => {
  // Dust II special case
  if (mapName === "dust_ii") return "Dust II";
  if (mapName === "Dust II") return "Dust II";
  if (
    mapName === "Cobblestone 2018" ||
    mapName === "cobblestone_2018" ||
    mapName === "de_cobblestone_2018"
  ) {
    return "Cobblestone";
  }

  // Convert snake_case to Title Case
  return mapName.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
};

